<template>
  <div class="con">
    <div class="con-inner">
      <h2 class="con-head">实验室入驻协议</h2>
      <div>
        <div
          v-for="(item, index) in textLines"
          :key="index"
          :class="{
            paragraph: item.paragraph,
            title: item.title,
            subTitle: item.subTitle,
          }"
        >
          {{ textFilter(item.text) }}
        </div>
        <div class="flex flex-row sign">
          <div class="flex-1">
            <div class="sign-line">甲方（盖章）：</div>
            <div class="sign-line">
              中国机械总院集团武汉材料保护研究所有限公司
            </div>
            <div
              v-for="(item, index) in signLines"
              :key="index"
              class="sign-line"
            >
              {{ item.text }}
            </div>
          </div>
          <div class="flex-1">
            <div class="sign-line">乙方（盖章）：</div>
            <div class="sign-line"></div>
            <div
              v-for="(item, index) in signLines"
              :key="index"
              class="sign-line"
            >
              {{ item.text }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      name: "中国机械总院集团武汉材料保护研究所有限公司公共服务平台",
      subName: "公共服务平台",
      textLines: [
        {
          paragraph: true,
          text: `甲 方： 中国机械总院集团武汉材料保护研究所有限公司`,
        },
        {
          paragraph: true,
          text: `乙 方：______________________________________`,
        },
        {
          paragraph: true,
          text: `签 订 时 间： ________ 年 _______ 月 _______ 日`,
        },
        {
          paragraph: true,
          text: `本协议双方在自愿、平等、公平及诚实信用原则的基础上，依照开放合作、互利共赢、共同发展的理念，根据《中华人民共和国合同法》等相关法律、法规的规定，经友好协商达成如下协议条款：`,
        },
        {
          title: true,
          text: `第一条 合作内容`,
        },
        {
          paragraph: true,
          text: `1. 甲方为乙方免费提供交易平台以及必要的后台管理系统所需要的用户名和密码，同时以线上宣传推广的形式帮助乙方实现检测服务供求对接的运作方式。`,
        },
        {
          paragraph: true,
          text: `2. 乙方通过甲方的平台展示单位基本情况、检测能力及范围，提供检测服务以及处理检测的相关交易事宜。`,
        },
        {
          title: true,
          text: `第二条 合作期限`,
        },
        {
          paragraph: true,
          text: `甲乙双方一致确认合作期限为____年，即从 _____ 年 ___月___日起至______年_____月_____日止。`,
        },
        {
          title: true,
          text: `第三条 双方权利与义务`,
        },
        {
          subTitle: true,
          text: `1. 甲方权利与义务`,
        },
        {
          paragraph: true,
          text: `1) 甲方负责按合同规定，保证{name}系统的正常运行；同时应尽可能在现有技术条件下对交易平台进行系统改进、功能提升和个性化修改等工作。`,
        },
        {
          paragraph: true,
          text: `2) 在相关业务的宣传工作中，甲方不得损害乙方的名称权、名誉权等非财产权利。`,
        },
        {
          paragraph: true,
          text: `3) 如遇甲方原因造成的平台服务中断时，甲方应及时排除故障并在第一时间内恢复平台的运行。`,
        },
        {
          paragraph: true,
          text: `4) 未经乙方同意，甲方不得将本协议的内容透露给第三方。`,
        },
        {
          paragraph: true,
          text: `5) 甲方对乙方在本平台上提供的单位信息、检测能力、服务质量等方面拥有监督权利，若发现乙方的技术能力和服务质量无法满足甲方的要求时，甲方有权单方终止本协议。`,
        },
        {
          paragraph: true,
          text: `6) 甲方作为平台的所有者和管理者，有权对乙方的检测活动进行监督和管理。对于严重损害公共权益或甲方利益的检测机构，甲方有权终止其继续使用本平台，同时支持和协助检测客户、有关行政机关对其进行追索和查处。`,
        },
        {
          subTitle: true,
          text: `2．乙方权利与义务`,
        },
        {
          paragraph: true,
          text: `1) 乙方应当具有相关行政部门颁发的《营业执照》，具备开展检验检测活动的设备、环境、人员、能力等条件，并取得检验检测相关资质，
          同时乙方保证提交给甲方的上述相关证明材料真实、合法、可靠，保证提供的检测服务满足甲方的要求，并对其负全部的经济损失及法律责任。
          乙方应提交《营业执照》、检验检测资质证书等复印件，交予甲方存档。`,
        },
        {
          paragraph: true,
          text: `2) 乙方保证其发布在甲方{name}上的信息合法、真实和有效，并且保证不存在任何虚构、错误及误导的信息，否则乙方将承担全部的经济损失及法律责任。`,
        },
        {
          paragraph: true,
          text: `3) 乙方承诺在利用甲方{name}开展检验检测在线服务等活动时严格遵守《中华人民共和国消费者权益保护法》等相关法律法规，尊重检测客户的隐私权和其他法定权利。
          乙方同时严格遵守甲方与其他关联方所签协议书中甲方需要承担的与检测客户权益相关的义务和责任。乙方已知悉并接受甲方在{name}上发布的《免责声明》。`,
        },
        {
          paragraph: true,
          text: `4) 乙方在双方约定的检测期限内，严格按甲方要求的检测标准或技术要求实施检测，并及时、准确、完整的出具检测报告，对检测报告的准确性负责，承担相应的法律责任。`,
        },
        {
          paragraph: true,
          text: `5) 乙方未能及时提供检测报告，或提供检测报告存在质量问题，导致平台用户投诉、差评、追求赔偿责任等情况累计3次，乙方除承担相应责任(赔偿检测客户和甲方的损失)外，
          甲方可以视情况处以暂时或永久终止本协议。乙方在检测过程中因操作不当或设备故障，造成客户样品损毁时，需向甲方赔偿，具体赔偿事宜由双方协商确定（样品的赔偿标准是否可量化或细化？）。`,
        },
        {
          paragraph: true,
          text: `6) 乙方不得以任何借口将甲方委托的检测工作转包给其他实验室。`,
        },
        {
          paragraph: true,
          text: `7) 乙方实验室认可、认定的范围或实验室人员、设备等资源发生变化，尤其是变化将影响到委派的检测项目时，乙方有义务在三个工作日内书面告知甲方，并详细说明变化的内容和原因。`,
        },
        {
          paragraph: true,
          text: `8) 乙方应对甲方提供的技术资料、检测结果及商业资料保密，未经甲方书面许可不得以任何形式向任何第三方泄露。双方约定，无论本协议是否变更、解除、终止，本条款均有效。`,
        },
        {
          paragraph: true,
          text: `9) 在相关业务的宣传工作中，乙方不得损害甲方的名称权、名誉权等非财产权利。甲方有权对乙方的宣传内容进行事先审核。对于甲方的任何修改要求和建议，乙方应该立即接受并改正。`,
        },
        {
          paragraph: true,
          text: `10) 未经甲方事先书面同意，乙方不得将本协议的任何内容透露给第三方。`,
        },
        {
          paragraph: true,
          text: `11)乙方理解甲方为了网站的正常运行或基于市场整体利益考虑及经营需要，定期或不定期地对网站进行停机维护或对其网站的服务内容、版面布局、页面设计等有关方面进行调整，
          如因此类情况而影响甲方本合同项下义务的履行，乙方给予充分的谅解，不对此追究法律责任，但甲方有义务提前告知乙方并预告恢复日期。`,
        },
        {
          title: true,
          text: `第四条 保密`,
        },
        {
          paragraph: true,
          text: `1．双方应对其因履行本协议而取得的双方中任何一方的各种形式的任何技术或商业信息进行保密。`,
        },
        {
          paragraph: true,
          text: `2．需要保密的信息包括但不限于下列信息：`,
        },
        {
          paragraph: true,
          text: `1) 样品信息、客户信息、原始数据、检验检测结果，及其它与检验检测交易有关的信息。`,
        },
        {
          paragraph: true,
          text: `2) 本协议的条款与条件，以及本协议有关的全部价格、收费以及发票信息。`,
        },
        {
          paragraph: true,
          text: `3) 第三方的保密信息，或对某一方有保密义务的信息。`,
        },
        {
          paragraph: true,
          text: `4) 任何被另一方清楚认定为保密的信息，无论是载于有形媒体或由口头作出的。`,
        },
        {
          paragraph: true,
          text: `5) 甲乙双方的其他商业秘密。`,
        },
        {
          paragraph: true,
          text: `6) 甲乙双方的文件与谈判内容、记录、电函往来。`,
        },
        {
          paragraph: true,
          text: `7) 一方向另一方披露的保密信息（包括甲方向乙方提供的统计数据）应当属于披露方所有。`,
        },
        {
          title: true,
          text: `第五条 违约责任`,
        },
        {
          paragraph: true,
          text: `1. 除本协议另有约定外，如甲乙双方中任何一方违反本协议，违约方应向守约方赔偿相应的损失。`,
        },
        {
          paragraph: true,
          text: `2. 如因乙方提供虚假信息、检测报告准确性、公正性存在问题或进行其他违法交易而造成的损失，甲方有权向乙方提出赔偿。`,
        },
        {
          title: true,
          text: `第六条 不可抗力`,
        },
        {
          paragraph: true,
          text: `1.“不可抗力”是指在本协议签订后发生的、受影响一方无法预见、无法避免并无法克服的客观情况。
          鉴于网络所具有的特殊性质，不可抗力还包括黑客攻击、计算机病毒发作、银行和电信部门技术调整等非因某一方故意或者过失而造成另一方未能按照本协议的约定提供服务的情况。`,
        },
        {
          paragraph: true,
          text: `2.因受不可抗力影响而不能履行或不能完全履行本协议的一方可以部分或全部免除履行其责任。
          不可抗力发生后，双方须立即协商继续履行本协议之相关事宜，并就此签订临时协议，临时协议的效力在该不可抗力及其影响终止或消除时终止。
          如不可抗力及其影响在发生一个月后仍未终止或消除，则双方可协商终止本协议。`,
        },
        {
          title: true,
          text: `第七条 适用法律与争议的解决`,
        },
        {
          paragraph: true,
          text: `1.除本协议另有规定外，甲乙双方就本协议或本协议之履行而产生的一切争议，均应首先通过友好协商的方式解决。如不能协商解决，任何一方均有权提请甲方所在地人民法院裁决。`,
        },
        {
          paragraph: true,
          text: `2.本协议部分条款的效力依本协议之规定而被终止或被宣告无效的，不影响本协议保密条款及其他条款的效力。`,
        },
        {
          title: true,
          text: `第八条 合同的变更与终止`,
        },
        {
          paragraph: true,
          text: `1.本协议之变更须经双方同意并采取书面形式确认。在双方未达成一致意见的情况下，原协议继续有效。任何一方无正当理由，不得擅自单方面终止本协议。`,
        },
        {
          paragraph: true,
          text: `2.在下列情况下，可以终止本协议：（1）本协议期满；（2）双方协商；（3）因不可抗力导致；（4）一方被整顿、清算或破产；（5）乙方未经甲方事先书面同意以任何名义、方式转租、转让、转借平台使用权的；（6）乙方丧失检测检验相关资质。`,
        },
        {
          paragraph: true,
          text: `3.本协议未尽事宜，双方可另行协商达成补充协议，补充协议与本协议不一致的地方，以补充协议为准。`,
        },
        {
          title: true,
          text: `第九条 合同的效力`,
        },
        {
          paragraph: true,
          text: `1.协议经双方法定代表人或授权签署人签字盖章后有效。`,
        },
        {
          paragraph: true,
          text: `2.协议合作期满前30 日内，甲乙双方协商本协议续约事宜。`,
        },
        {
          paragraph: true,
          text: `3.协议一式陆份，甲乙双方各执叁份，具有同等法律效力。`,
        },
      ],
      signLines: [
        { text: "法定代表人或授权签署人（签字）：" },
        { text: "联系人：" },
        { text: "联系方式：" },
        { text: "开户行：" },
        { text: "账号：" },
        { text: "______年_____月_____日" },
      ],
    };
  },
  methods: {
    textFilter(val) {
      return val
        .replaceAll("{name}", this.name)
        .replaceAll("{subName}", this.subName);
    },
  },
};
</script>
<style scoped lang="scss">
@import "./common.scss";
.sign {
  padding: 50px 0;
  &-line {
    margin-bottom: 15px;
    font-size: 16px;
    min-height: 20px;
  }
}
</style>
